import React from 'react';
import PropTypes from 'prop-types';
import { dates } from '@unite-us/client-utils';
import { PrimaryButton, SecondaryButton } from '../../common/TailwindComponents';
import '../stylesheets/EnrollmentWorkflow.scss';
export var ClientDetails = function ClientDetails(_ref) {
  var contact = _ref.contact,
    goBackToFacesheet = _ref.goBackToFacesheet,
    plan = _ref.plan,
    stepForward = _ref.stepForward;
  return /*#__PURE__*/React.createElement("div", {
    className: "p-6 pt-0"
  }, /*#__PURE__*/React.createElement("p", {
    className: "enrollment-request-label mb-4"
  }, "Review the client and social care coverage plan details below."), /*#__PURE__*/React.createElement("dl", null, /*#__PURE__*/React.createElement("dt", {
    className: "enrollment-request-label mb-2"
  }, "Client Name"), /*#__PURE__*/React.createElement("dd", {
    className: "enrollment-request-value ml-0"
  }, contact.full_name), /*#__PURE__*/React.createElement("dt", {
    className: "enrollment-request-label font-extrabold mb-2 mt-6"
  }, "Date of Birth"), /*#__PURE__*/React.createElement("dd", {
    className: "enrollment-request-value ml-0"
  }, dates.formatDate(contact.date_of_birth)), /*#__PURE__*/React.createElement("dt", {
    className: "enrollment-request-label font-extrabold mb-2 mt-6"
  }, "Social Care Coverage"), /*#__PURE__*/React.createElement("dd", {
    className: "enrollment-request-value ml-0"
  }, plan === null || plan === void 0 ? void 0 : plan.name), /*#__PURE__*/React.createElement("dt", {
    className: "enrollment-request-label font-extrabold mb-2 mt-6"
  }, "Start Date"), /*#__PURE__*/React.createElement("dd", {
    className: "enrollment-request-value ml-0"
  }, "Social care coverage will start once the client is enrolled."), /*#__PURE__*/React.createElement("dt", {
    className: "enrollment-request-label font-extrabold mb-2 mt-6"
  }, "End Date"), /*#__PURE__*/React.createElement("dd", {
    className: "enrollment-request-value ml-0"
  }, "Social care coverage will end when the client is disenrolled.")), /*#__PURE__*/React.createElement("div", {
    className: "bg-white px-6 py-4 flex items-center justify-end space-x-6"
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    label: "Cancel",
    "data-testid": "client-details-cancel-button",
    onClick: goBackToFacesheet
  }), /*#__PURE__*/React.createElement(PrimaryButton, {
    label: "Next",
    "data-testid": "client-details-next-button",
    onClick: stepForward
  })));
};
ClientDetails.propTypes = {
  contact: PropTypes.object,
  goBackToFacesheet: PropTypes.func.isRequired,
  plan: PropTypes.object.isRequired,
  stepForward: PropTypes.func.isRequired
};
ClientDetails.defaultProps = {
  contact: {}
};
//# sourceMappingURL=ClientDetails.js.map